import * as React from "react";
import { Table, TableBody, TableRow, TableCell, TableHead } from '@material-ui/core';
import { ShareTableModal } from '../modal/ShareTableModal';
import { MoneyLessBRL, NumberLessBRL } from 'src/services';

// tslint:disable-next-line:no-empty-interface
export interface IShareTableProps {
    title: string;
    table_main: IShareTableData[];
    table_01: IShareTableData[];
    table_02: IShareTableData[];
    showFirstTable?: boolean,
    showMax: number;
}

// tslint:disable-next-line:no-empty-interface
export interface IShareTableState {}

export interface IShareTableData{
    billing: number;
    name: string;
    value: number;
    volume: number;
}

// statless component
export const ShowShareTable = ({ data, styleValue }: { data: IShareTableData[], styleValue?: number } ) => {
    const positiveClassName = (styleValue != null && styleValue !== undefined && styleValue === 1) ? "content-positive content-label": "";
    const negativeClassName = (styleValue != null && styleValue !== undefined && styleValue === 1) ? "content-negative content-label": "";
    return (
    <Table>
        <TableHead>
            <TableRow>
                <TableCell style={{paddingRight: 0}} />
                <TableCell style={{paddingRight: 0}}>Nome</TableCell>
                {data && data[0] && data[0].billing && <TableCell style={{paddingRight: 0}}>Faturamento</TableCell>}
                {data && data[0] && data[0].volume && <TableCell style={{paddingRight: 0}}>Volume</TableCell>}
                <TableCell style={{paddingRight: 0}}>Valor</TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
            { data && data.map( (row:IShareTableData, index) => {
                return (<TableRow key={index}>
                    <TableCell style={{paddingRight: 0, paddingLeft: 10}}> { index + 1 } </TableCell>
                    <TableCell style={{paddingRight: 0}}>{row.name}</TableCell>
                    {row.billing && <TableCell style={{paddingRight: 0}}>{MoneyLessBRL(row.billing.toString())}</TableCell>}
                    {row.volume && <TableCell style={{paddingRight: 0}}>{NumberLessBRL(row.volume.toString())}</TableCell>}
                    {row.value != null && row.value !== undefined ? ( 
                        <TableCell style={{paddingRight: 0}}>
                            {row.value >= 0 ? (
                                    <span className={positiveClassName} >{row.value.toString().replace('.',',') + '%'}</span>
                                ) : (
                                    <span className={negativeClassName} >{row.value.toString().replace('.',',') + '%'}</span>
                                )
                            }
                        </TableCell>
                    ) : (
                        <TableCell style={{paddingRight: 0}} />
                    )}
                </TableRow>)
            }
            ) }
        </TableBody>
    </Table>
    );
};

export class ShareTable extends React.Component<IShareTableProps, IShareTableState> {
    public render() {
      return (
        <div>
          <div style={{height: 334, overflowX: 'auto', overflowY: 'hidden'}}>
                <ShowShareTable  data={this.props.table_main.filter( (element:IShareTableData, index: number) => index<=this.props.showMax )} />
            </div>
            <ShareTableModal table_01={this.props.table_01} table_02={this.props.table_02} showFirstTable={this.props.showFirstTable} title={this.props.title}/>
        </div>
      )
    }
}



// WEBPACK FOOTER //
// ./src/component/shared/share/table/ShareTable.tsx